// src/plugins/removeReadonlyPlugin.js
export default {
    install(Vue) {
        Vue.mixin({
            mounted() {
                this.$nextTick(() => {
                    const inputs = document.querySelectorAll('input.multiselect__input[readonly]');
                    inputs.forEach(input => {
                        const removeReadonly = () => {
                            input.removeAttribute('readonly');
                        };
                        
                        input.addEventListener('focus', removeReadonly);
                        input.addEventListener('click', removeReadonly);
                        
                        input._removeReadonlyListeners = {
                            focus: removeReadonly,
                            click: removeReadonly
                        };
                    });
                });
            }
        });
    }
};